export const TEST_ID = 'invitationsTableSection';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const DEFAULT_PAGE_SIZE = 10;

export const EMAIL_COLUMN_KEY = 'invitee';

export const EMPTY_CELL_TEXT = '—';

export const EXPIRES_COLUMN_KEY = 'expiresAt';

export const ROLE_COLUMN_KEY = 'roles';

export const ROLE_SEPARATOR = ', ';

export const SENT_COLUMN_KEY = 'createdAt';

export const STATUS_COLUMN_KEY = 'status';
